
<mat-form-field style="margin-top: 15px;">

    <mat-label>{{name}}</mat-label>
    <div style=" display: flex;justify-content: end;margin-bottom: 15px;height:20px">
      <span *ngIf="viewMatSpinner && name=='comuni'">
        <mat-icon>
          <mat-spinner color="accent" diameter="20"></mat-spinner>
        </mat-icon>
        Attendi il caricamento
      </span>
    </div>
  
      <mat-chip-grid #chipGrid aria-label="Fruit selection">
        <ng-container *ngIf="deleghe.length>0">
          <ng-container *ngFor="let dato of datiSelezionati(); trackBy: trackChatMessage" >
            <mat-chip-row *ngIf="deleghe.includes(dato?.id)" (removed)="remove(dato)" disabled>
              {{dato?.denominazione!}}
              <button matChipRemove [attr.aria-label]="'remove ' + dato">
                <mat-icon class="material-symbols-outlined">cancel</mat-icon>
              </button>
            </mat-chip-row>
            <mat-chip-row *ngIf="!deleghe.includes(dato?.id)" (removed)="remove(dato)">
              {{dato?.denominazione!}}
              <button matChipRemove [attr.aria-label]="'remove ' + dato">
                <mat-icon class="material-symbols-outlined">cancel</mat-icon>
              </button>
            </mat-chip-row>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="deleghe.length==0">
            <mat-chip-row  *ngFor="let dato of datiSelezionati(); trackBy: trackChatMessage" (removed)="remove(dato)">
              {{dato?.denominazione!}}
              <button matChipRemove [attr.aria-label]="'remove ' + dato">
                <mat-icon class="material-symbols-outlined">cancel</mat-icon>
              </button>
            </mat-chip-row>
        </ng-container>
      </mat-chip-grid>
      <input
        [name]="name"
        [placeholder]="placeholder"

        #luogoInput
        [ngModel]="currentValue()"
        (ngModelChange)="currentValue.set($event)"
        [matChipInputFor]="chipGrid"
        [matAutocomplete]="auto"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
        (input)="filtereddatiSelezionati()"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <ng-container *ngFor="let datoFiltered of filteredDatiSelezionati(); trackBy: trackChatMessage ">
          <mat-option  *ngIf="deleghe.includes(datoFiltered?.id)" [value]="datoFiltered" disabled>
            {{datoFiltered?.denominazione!}}
          </mat-option>
          <mat-option  *ngIf="!deleghe.includes(datoFiltered?.id)" [value]="datoFiltered">
            {{datoFiltered?.denominazione!}}
          </mat-option>
  
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>
  

  